// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/client-" + (chunkId === 35 ? "player" : chunkId) + "-" + {"35":"c2954d8290f089f3551a","354":"1d23f2427b10401b475b","804":"880afad5ca8fa1994e8a"}[chunkId] + ".js";
};